import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { GET, POST, PUT, DELETE, loading, alert, Select } from "../components/CustomComponent";

const sectionCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(18, 125, 255, 0.10)",
  borderRadius: 24,
  boxShadow: "0 14px 32px rgba(12, 118, 229, 0.06)",
};

const summaryCardStyle = {
  background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
  border: "1px solid rgba(18, 125, 255, 0.10)",
  boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
};

const modalInputStyle = {
  borderRadius: 12,
  border: "1px solid #c9d7e3",
  background: "#ffffff",
  color: "#1b3950",
  boxShadow: "none",
};

const modalLabelStyle = {
  color: "#0b4f84",
  fontSize: "0.82rem",
  fontWeight: 800,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  marginBottom: 8,
};

const TYPE_OPTIONS = [
  { value: "customer", label: "ลูกค้า" },
  { value: "vendor", label: "ผู้ขาย / ผู้รับจ้าง" },
  { value: "both", label: "เป็นทั้งลูกค้าและผู้ขาย" },
];

const TYPE_STYLE = {
  customer: { background: "rgba(12, 117, 230, 0.14)", color: "#0b4f84" },
  vendor: { background: "rgba(245, 166, 35, 0.16)", color: "#b97007" },
  both: { background: "rgba(47, 181, 114, 0.14)", color: "#188251" },
};

const partnerFormDefaults = {
  uid: "",
  partner_code: "",
  partner_type: "customer",
  name: "",
  tax_id: "",
  branch: "",
  address: "",
  contact_name: "",
  phone: "",
  email: "",
  payment_term_days: "0",
  note: "",
  is_active: true,
};

const typeLabel = (value) => TYPE_OPTIONS.find((item) => item.value === value)?.label || value;

const PartnerModal = ({ show, onHide, editData, onSave }) => {
  const [formData, setFormData] = useState(partnerFormDefaults);

  useEffect(() => {
    setFormData({
      ...partnerFormDefaults,
      uid: editData?.uid || "",
      partner_code: editData?.partner_code || "",
      partner_type: editData?.partner_type || "customer",
      name: editData?.name || "",
      tax_id: editData?.tax_id || "",
      branch: editData?.branch || "",
      address: editData?.address || "",
      contact_name: editData?.contact_name || "",
      phone: editData?.phone || "",
      email: editData?.email || "",
      payment_term_days: String(editData?.payment_term_days ?? 0),
      note: editData?.note || "",
      is_active: editData ? editData.is_active !== false : true,
    });
  }, [editData, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" contentClassName="border-0 shadow-lg overflow-hidden" dialogClassName="modal-dialog-scrollable">
      <Modal.Header
        closeButton
        className="border-0 p-4"
        style={{
          background: "radial-gradient(circle at top right, rgba(38, 218, 222, 0.28), transparent 24%), linear-gradient(135deg, #d9eeff 0%, #bfe1ff 44%, #e7f6ff 100%)",
        }}
      >
        <Modal.Title className="fw-bold" style={{ color: "#11324c", fontSize: "1.6rem" }}>
          {editData ? "แก้ไขข้อมูลลูกค้า/คู่ค้า" : "เพิ่มลูกค้า/คู่ค้า"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4" style={{ background: "linear-gradient(180deg, #fcfeff 0%, #f5faff 100%)" }}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label" style={modalLabelStyle}>ชื่อ (ตามหนังสือรับรอง)</label>
            <input type="text" name="name" className="form-control" style={modalInputStyle} value={formData.name} onChange={handleChange} placeholder="เช่น บริษัท ตัวอย่าง จำกัด" />
          </div>
          <div className="col-md-6">
            <label className="form-label" style={modalLabelStyle}>ประเภท</label>
            <select name="partner_type" className="form-select" style={modalInputStyle} value={formData.partner_type} onChange={handleChange}>
              {TYPE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label" style={modalLabelStyle}>เลขประจำตัวผู้เสียภาษี</label>
            <input type="text" name="tax_id" className="form-control" style={modalInputStyle} value={formData.tax_id} onChange={handleChange} placeholder="13 หลัก" />
          </div>
          <div className="col-md-6">
            <label className="form-label" style={modalLabelStyle}>สาขา</label>
            <input type="text" name="branch" className="form-control" style={modalInputStyle} value={formData.branch} onChange={handleChange} placeholder="สำนักงานใหญ่" />
          </div>
          <div className="col-12">
            <label className="form-label" style={modalLabelStyle}>ที่อยู่</label>
            <textarea name="address" className="form-control" style={modalInputStyle} rows={2} value={formData.address} onChange={handleChange} placeholder="ที่อยู่สำหรับออกเอกสาร" />
          </div>
          <div className="col-md-4">
            <label className="form-label" style={modalLabelStyle}>ผู้ติดต่อ</label>
            <input type="text" name="contact_name" className="form-control" style={modalInputStyle} value={formData.contact_name} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label" style={modalLabelStyle}>เบอร์โทร</label>
            <input type="text" name="phone" className="form-control" style={modalInputStyle} value={formData.phone} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label" style={modalLabelStyle}>อีเมล</label>
            <input type="email" name="email" className="form-control" style={modalInputStyle} value={formData.email} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label" style={modalLabelStyle}>เครดิตเทอม (วัน)</label>
            <input type="number" name="payment_term_days" className="form-control" style={modalInputStyle} value={formData.payment_term_days} onChange={handleChange} min="0" />
            <div className="small mt-1" style={{ color: "#6b8198" }}>0 = ชำระทันที</div>
          </div>
          <div className="col-md-8">
            <label className="form-label" style={modalLabelStyle}>หมายเหตุ</label>
            <input type="text" name="note" className="form-control" style={modalInputStyle} value={formData.note} onChange={handleChange} />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 py-4" style={{ background: "linear-gradient(180deg, rgba(243,249,255,0.84) 0%, rgba(248,252,255,0.98) 100%)" }}>
        <div className="d-flex flex-column flex-sm-row gap-3 w-100 justify-content-end">
          <button type="button" className="btn btn-secondary px-4 py-2 rounded-4" onClick={onHide}>ยกเลิก</button>
          <button type="button" className="btn btn-primary px-4 py-2 rounded-4" onClick={() => onSave(formData)}>บันทึกข้อมูล</button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default function Partners() {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [typeInput, setTypeInput] = useState("");
  const [filters, setFilters] = useState({ data_search: "", partner_type: "" });

  const getData = useCallback(async () => {
    loading(true);
    const result = await GET("v1/admin/partners", {
      page: 0,
      ...(filters.data_search ? { data_search: filters.data_search } : {}),
      ...(filters.partner_type ? { partner_type: filters.partner_type } : {}),
    });
    if (result?.status) setData(result.data || []);
    loading(false);
  }, [filters]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleSave = async (formData) => {
    if (!formData.name?.trim()) {
      await alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อลูกค้า/คู่ค้า");
      return;
    }
    if (!(await alert("", "info", "ยืนยัน", "ต้องการบันทึกข้อมูลนี้?", "บันทึก", "ยกเลิก"))) return;

    loading(true);
    const body = {
      partner_type: formData.partner_type,
      name: formData.name.trim(),
      tax_id: formData.tax_id?.trim() || undefined,
      branch: formData.branch?.trim() || undefined,
      address: formData.address?.trim() || undefined,
      contact_name: formData.contact_name?.trim() || undefined,
      phone: formData.phone?.trim() || undefined,
      email: formData.email?.trim() || undefined,
      payment_term_days: Number(formData.payment_term_days) || 0,
      note: formData.note?.trim() || undefined,
      is_active: !!formData.is_active,
    };

    const result = formData.uid
      ? await PUT(`v1/admin/partners/${formData.uid}`, body)
      : await POST("v1/admin/partners", body);
    loading(false);

    if (result?.status) {
      await alert("", "success", "สำเร็จ", "บันทึกข้อมูลเรียบร้อย");
      setShowModal(false);
      setEditData(null);
      getData();
    } else {
      await alert("", "warning", "แจ้งเตือน", result?.message || "บันทึกไม่สำเร็จ");
    }
  };

  const handleDelete = async (item) => {
    if (!(await alert("", "warning", "ลบข้อมูล", `ต้องการลบ ${item.name} ?`, "ลบ", "ยกเลิก"))) return;

    loading(true);
    const result = await DELETE(`v1/admin/partners/${item.uid}`);
    loading(false);

    if (result?.status) {
      await alert("", "success", "สำเร็จ", "ลบเรียบร้อย");
      getData();
    } else {
      await alert("", "warning", "แจ้งเตือน", result?.message || "ลบไม่สำเร็จ");
    }
  };

  const summaryCards = [
    { label: "ทั้งหมด", value: data.length, color: "#0c76e5", icon: "fa-address-book" },
    { label: "ลูกค้า", value: data.filter((item) => ["customer", "both"].includes(item.partner_type)).length, color: "#0b4f84", icon: "fa-user-tie" },
    { label: "ผู้ขาย / ผู้รับจ้าง", value: data.filter((item) => ["vendor", "both"].includes(item.partner_type)).length, color: "#b97007", icon: "fa-truck-field" },
    { label: "ปิดใช้งาน", value: data.filter((item) => item.is_active === false).length, color: "#566575", icon: "fa-ban" },
  ];

  return (
    <AppShell title="ลูกค้า / คู่ค้า" description="ทะเบียนลูกค้าและผู้ขาย ใช้เลือกตอนออกเอกสารการเงิน ไม่ต้องพิมพ์ที่อยู่และเลขภาษีซ้ำทุกครั้ง">
      <div className="row g-3 mb-4">
        {summaryCards.map((card) => (
          <div className="col-6 col-xl-3" key={card.label}>
            <div className="h-100 rounded-4 p-4 d-flex align-items-center gap-3" style={summaryCardStyle}>
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{ width: 44, height: 44, borderRadius: 12, background: `${card.color}1f`, color: card.color, fontSize: 18 }}
              >
                <i className={`fa-solid ${card.icon}`} />
              </div>
              <div>
                <p className="small text-uppercase text-secondary mb-1">{card.label}</p>
                <h3 className="h4 mb-0 fw-bold" style={{ color: card.color }}>{card.value}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 flex-wrap align-items-center filters-mobile-stack">
          <input
            type="text"
            className="form-control"
            value={searchInput}
            onChange={(event) => setSearchInput(event.target.value)}
            onKeyDown={(event) => event.key === "Enter" && setFilters({ data_search: searchInput.trim(), partner_type: typeInput })}
            placeholder="ค้นหาชื่อ เลขภาษี ผู้ติดต่อ..."
            style={{ width: "250px", borderRadius: "12px" }}
          />
          <div style={{ width: "200px" }}>
            <Select className="form-control" value={typeInput} options={TYPE_OPTIONS} placeholder="ทุกประเภท" onChange={(value) => setTypeInput(value)} />
          </div>
          <button
            type="button"
            className="btn btn-primary px-4"
            onClick={() => setFilters({ data_search: searchInput.trim(), partner_type: typeInput })}
            style={{ borderRadius: "12px" }}
          >
            ค้นหา
          </button>
          <button
            type="button"
            className="btn btn-light px-4"
            onClick={() => {
              setSearchInput("");
              setTypeInput("");
              setFilters({ data_search: "", partner_type: "" });
            }}
            style={{ borderRadius: "12px", border: "1px solid rgba(18, 125, 255, 0.14)", color: "#4f6d83" }}
          >
            ล้างค่า
          </button>
        </div>
        <button
          onClick={() => {
            setEditData(null);
            setShowModal(true);
          }}
          className="btn btn-primary px-4 flex-shrink-0"
          style={{ borderRadius: "12px" }}
        >
          + เพิ่มลูกค้า/คู่ค้า
        </button>
      </div>

      <div className="p-3 p-md-4" style={sectionCardStyle}>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium">รหัส</th>
                <th className="text-secondary fw-medium">ชื่อ</th>
                <th className="text-secondary fw-medium text-nowrap">ประเภท</th>
                <th className="text-secondary fw-medium">เลขภาษี</th>
                <th className="text-secondary fw-medium">ผู้ติดต่อ</th>
                <th className="text-secondary fw-medium text-center text-nowrap">เครดิต</th>
                <th className="text-secondary fw-medium text-center">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item) => (
                  <tr key={item.uid}>
                    <td data-label="รหัส" className="fw-semibold text-nowrap" style={{ color: "#0b4f84" }}>{item.partner_code || "-"}</td>
                    <td data-label="ชื่อ">
                      <div className="fw-medium">{item.name}</div>
                      {item.branch ? <div className="small text-secondary">{item.branch}</div> : null}
                    </td>
                    <td data-label="ประเภท" className="text-nowrap">
                      <span
                        className="rounded-pill px-3 py-1 small fw-semibold text-nowrap d-inline-block"
                        style={TYPE_STYLE[item.partner_type] || TYPE_STYLE.customer}
                      >
                        {typeLabel(item.partner_type)}
                      </span>
                    </td>
                    <td data-label="เลขภาษี" className="text-nowrap">{item.tax_id || "-"}</td>
                    <td data-label="ผู้ติดต่อ">
                      <div>{item.contact_name || "-"}</div>
                      <div className="small text-secondary">{item.phone || item.email || ""}</div>
                    </td>
                    <td data-label="เครดิต" className="text-center text-nowrap">
                      {item.payment_term_days ? `${item.payment_term_days} วัน` : "ทันที"}
                    </td>
                    <td data-label="จัดการ" className="text-center text-nowrap">
                      <button
                        className="btn btn-sm btn-outline-secondary rounded-3 me-1"
                        title="แก้ไข"
                        onClick={() => {
                          setEditData(item);
                          setShowModal(true);
                        }}
                      >
                        <i className="fa-solid fa-pen" />
                      </button>
                      <button className="btn btn-sm btn-outline-danger rounded-3" title="ลบ" onClick={() => handleDelete(item)}>
                        <i className="fa-solid fa-trash" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-secondary py-5">ยังไม่มีข้อมูลลูกค้า/คู่ค้า</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <PartnerModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setEditData(null);
        }}
        editData={editData}
        onSave={handleSave}
      />
    </AppShell>
  );
}
